/** @format */

import styled from 'styled-components';

export const CardAvailabilityAvailableFrom = styled.div`
  font-weight: normal;
  margin-bottom: 0;
  font-size: 14px;
  line-height: 1.3;
  margin-top: 0;
  margin-top: 10px;
  text-align: center;

  @media screen and (max-width: ${props => props.theme.breakpoints.lg}) {
    margin-top: 0;
    font-size: 10px;
    display: none;
  }
`;

export const BookCardStartingPriceFrom = styled.span`
  text-decoration-line: strikethrough;
`;

export const GeneralFrom = styled.div`
  span {
    &.general_from_price {
      color: ${props => props.theme.colors.joivy.pink};
      font-family: ${({ theme }) => theme.font.title};
      font-size: clamp(1.125rem, 1.0417rem + 0.3704vw, 1.375rem);
      letter-spacing: clamp(0.0225rem, 0.0208rem + 0.0074vw, 0.0275rem);
    }
  }
`;
